import { createContext } from 'react';

var AccordionContext = /*#__PURE__*/createContext({
  openIndices: [],
  toggleAccordion: function toggleAccordion() {},
  oneAtATime: false
});
var AccordionContext$1 = AccordionContext;

export { AccordionContext$1 as default };
//# sourceMappingURL=AccordionContext.js.map
